import { useEffect, useState } from "react";

const useLocation = () => {
    const [location, setLocation] = useState(
        localStorage.getItem("userLocation") || "Select Location"
    );

  const detectLocation = () => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
        async (position) => {
            const { latitude, longitude } = position.coords;

            try {
                const res = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
                );

                const data = await res.json();

                const area =
                    data.address?.suburb ||
                    data.address?.neighbourhood ||
                    data.address?.road ||
                    data.address?.village ||
                    "";

                const city =
                    data.address?.city ||
                    data.address?.town ||
                    data.address?.state ||
                    "";

                const pincode =
                    data.address?.postcode || "";

                const exactLocation = [area, city, pincode]
                    .filter(Boolean)
                    .join(", ");

                const finalLocation =
                    exactLocation || "Unknown Location";

                setLocation(finalLocation);
                localStorage.setItem(
                    "userLocation",
                    finalLocation
                );

                console.log(data);
            } catch (error) {
                console.error(error);
            }
        },
        (err) => console.error(err)
    );
};

    const updateLocation = (value) => {
        setLocation(value);
        localStorage.setItem("userLocation", value);
    };

    useEffect(() => {
        if (!localStorage.getItem("userLocation")) {
            detectLocation();
        }
    }, []);

    return {
        location,
        updateLocation,
        detectLocation
    };
};

export default useLocation;